import { Basics } from '../_app/cuchillo/core/Basics';
import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import { DataHolder } from '../DataHolder';
import Header from '../layout/Header';
import DefaultNoScroll from './DefaultNoScroll';

export default class Contact extends DefaultNoScroll {
//==================================================================================================================
//          CONSTRUCTOR
//==================================================================================================================
  
  constructor() {
    super();
    Basics.oldPage = "contact";
    DataHolder.update();
    this.enableClock();

    Header.mode = "INVERT";
  }

  beforeShow() {
    super.beforeShow();
    Header.title.hide();
  }

  enableClock() {
    this.updateTime();
  }

  updateTime() {
    const el = document.querySelector('[data-time]');
    if (!el) return;

    const now = new Date();
    const madridTime = now.toLocaleTimeString('es-ES', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      timeZone: 'Europe/Madrid',
      hour12: false,
    });

    el.textContent = "Spain " + madridTime + " (GMT +2)";

    this.timer = setTimeout(()=> {
      this.updateTime();
    }, 1000);
  }
}

ControllerPage._addPage("contact", Contact)
